export const scaleByDecimals = (
  value: number | string,
  decimals: number,
): string => {
  if (decimals <= 0) {
    const n = Number(String(value).replace(/[^0-9.]/g, ''))
    return Number.isFinite(n) ? String(Math.floor(n)) : '0'
  }
  let raw = String(value)
  raw = raw.replace(/,/g, '').replace(/[^0-9.]/g, '')
  if (!raw) return '0'
  if (raw.startsWith('.')) raw = '0' + raw
  const [intPartRaw, fracPartRaw = ''] = raw.split('.')
  const intPart = intPartRaw || '0'
  const fracPart = fracPartRaw || ''
  const fracLen = fracPart.length

  if (decimals <= fracLen) {
    const digits = intPart + fracPart.slice(0, decimals)
    const trimmed = digits.replace(/^0+(?=\d)/, '')
    return trimmed || '0'
  }
  const zeros = '0'.repeat(decimals - fracLen)
  const digits = intPart + fracPart + zeros
  const trimmed = digits.replace(/^0+(?=\d)/, '')
  return trimmed || '0'
}

export const priceToWeiString = (
  price: number | string,
  decimals: number,
): string => scaleByDecimals(price, decimals)

export const monthsToSeconds = (months: number): number =>
  Math.floor(months * 30 * 24 * 60 * 60)

export const daysToSeconds = (days: number): number =>
  Math.floor(days * 24 * 60 * 60)

export const percentToBips = (pct: number): number => Math.floor(pct * 100)
